import { render } from "./BioPage.vue?vue&type=template&id=4d4de47c"
const script = {}

import "./BioPage.vue?vue&type=style&index=0&id=4d4de47c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__